import { registerLazyPopupRenderer } from "@/entities/bottom-popup"

registerLazyPopupRenderer("easy-match", () => import("../ui/easy-match-popup"))
